
/**
 * @author Félix Proulx <felix.proulx@cossette.com>, Christine Daneau-Pelletier <christine.daneau.pelletier@gmail.com>
 * @description GTM Tracking
 */
export class Tracking {

    private $tracked:NodeListOf<HTMLElement> = null;

    public constructor( tracked = null ) {
        this.$tracked = tracked;
        if (this.$tracked && this.$tracked.length > 0) {
            this.init()
        }
    }

    /**
     * used to update listeners after hub updates.
     */
    public hubUpdateTracker():void {
        document.querySelector('.hub-results').querySelectorAll('[data-track-cta]').forEach(item => {
            item.addEventListener('click', this.fireEvent);
        });
    }

    /**
     * used to send data after wpcf7submit events.
     */
    public contactFormSevenSubmitEvents(e):void {

        // todo for testing remove after QA
        // e.preventDefault();

        let trackedItem:HTMLElement = e.target.querySelector('.wpcf7-submit');

        if (trackedItem) {
            let data:{[key: string]: string} = {
                "event": "ContentInteraction",
                "CTAname": trackedItem.getAttribute('data-track-cf7-submit'),
                "action_name": trackedItem.getAttribute('data-track-cf7-submit-name')
            };

            if(typeof(window.dataLayer) !== 'undefined') {
                try {
                    window.dataLayer.push(data);
                } catch (e) {
                    console.log('Datalayer error:' + e);
                }
            }
            // todo for testing remove after QA
            // console.log(data);
        }
    }

    /**
     * fire GTM event using DOM's data-attributes
     */
    private fireEvent(e):void {

        // todo for testing remove after QA
        // e.preventDefault();

        let trackedItem:HTMLElement = e.target.closest('[data-track-cta]');
        if (trackedItem) {
            let data:{[key: string]: string} = {
                "event": "ContentInteraction",
                "CTAname": trackedItem.getAttribute('data-track-cta'),
                "action_name": trackedItem.getAttribute('data-track-name')
            };

            if(typeof(window.dataLayer) !== 'undefined') {
                try {
                    window.dataLayer.push(data);
                } catch (e) {
                    console.log('Datalayer error:' + e);
                }
            }
            // todo for testing remove after QA
            // console.log(data);
        }
    }

    /**
     * add listeners on tracked items in DOM on page-load
     **/
    private init():void {
        this.$tracked.forEach(item => {
            item.addEventListener('click', this.fireEvent);
        });
    }
}
